import React from 'react'
import { alertService } from '../services/alert-service'
import { IconButton, Icon, Snackbar } from '@material-ui/core'
import MuiAlert from '@material-ui/lab/Alert'

const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />
})

const MatxSnackbar = (props) => {
    const closeMessage = (e) => {
        alertService.removeMessage(props.message)
        alertService.clearAllMessages()
    }

    return (
        <Snackbar
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            open={props.message.count > 0}
            autoHideDuration={props.message.timeoutInMilliseconds}
            onClose={closeMessage}
            ContentProps={{
                'aria-describedby': 'message-id',
            }}
            action={[
                <IconButton
                    key="close"
                    aria-label="close"
                    color="inherit"
                    onClick={closeMessage}
                >
                    <Icon>close</Icon>
                </IconButton>,
            ]}
        >
            <Alert
                onClose={closeMessage}
                severity={props.message.type}
                sx={{ width: '100%' }}
            >
                {props.message.message}
            </Alert>
        </Snackbar>
    )
}

export default MatxSnackbar
